<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">
      {{"Set Component Column Order" | translate | async}}
    </span>
    <mat-icon class="ttmodal__close-button" (click)="close()" matTooltip="Close Popup">
      close
    </mat-icon>
  </div>
    <div class="ttmodal__body">
      <div class="column-row" *ngFor="let column of columns; let i = index">
        <div class="column-item">
          <span class="column-title">
              {{column.ColumnDisplayName}}
          </span>
          <div class="column-actions">
              <mat-icon
                  class="action-icon"
                  matTooltip="Move Up"
                  [class.button-hide]="i === 0"
                  (click)="moveUp(i)">
                  arrow_upward
              </mat-icon>
              <mat-icon
                  class="action-icon"
                  [class.button-hide]="i === columns.length - 1"
                  (click)="moveDown(i)"
                  matTooltip="Move Down">
                  arrow_downward
              </mat-icon>
          </div>
        </div>
      </div>
  </div>
</div>